export const roomTypeTranslations = {
  'Living Room': 'Oturma Odası',
  'Bedroom': 'Yatak Odası',
  'Kitchen': 'Mutfak',
  'Bathroom': 'Banyo',
  'Dining Room': 'Yemek Odası',
  'Office': 'Ofis',
  'Children Room': 'Çocuk Odası',
  'Hallway': 'Koridor',
  'Balcony': 'Balkon'
};

export const styleTranslations = {
  'scandinavian': 'İskandinav',
  'parisian': 'Paris',
  'eclectic': 'Eklektik',
  'contemporary': 'Çağdaş',
  'futuristic': 'Fütüristik',
  'minimalist': 'Minimalist',
  'japandi': 'Japandi',
  'bohemian': 'Bohem',
  'indian': 'Hint',
  // Additional options translations
  'scandanavian': 'İskandinav', // Note: "scandanavian" is kept as provided.
  'modern': 'Modern',
  'countryside': 'Kırsal',
  'coastal': 'Kıyı',
  'wooden': 'Ahşap',
  'industrial': 'Endüstriyel',
  'italian': 'İtalyan',
  'traditional': 'Geleneksel'
};

export const colorThemeTranslations = {
  'original': 'Orijinal',
  'red': 'Kırmızı',
  'blue': 'Mavi',
  'green': 'Yeşil',
  'yellow': 'Sarı',
  'brown': 'Kahverengi',
  'white': 'Beyaz',
  'black': 'Siyah',
  'grey': 'Gri',
  'purple': 'Mor',
  'pink': 'Pembe',
  'orange': 'Turuncu'
};

export const metadataTranslations = {
  'Workflow': 'İş Akışı',
  'Style': 'Stil',
  'Mode': 'Mod',
  'Created At': 'Oluşturma Tarihi',
  'Prompt': 'Komut',
  'Negative Prompt': 'Negatif Komut',
  'interior': 'İç Mekan',
  'exterior': 'Dış Mekan',
  'enhancement': 'İyileştirme',
  'contemporary': 'Çağdaş',
  'Bedroom': 'Yatak Odası',
  'Living Room': 'Oturma Odası',
  'Kitchen': 'Mutfak',
  'Bathroom': 'Banyo',
  'Dining Room': 'Yemek Odası',
  'Office': 'Ofis',
  'Room Type': 'Oda Tipi',
  'Color Theme': 'Renk Teması',
  'scandanavian': 'İskandinav',
  'modern': 'Modern',
  'countryside': 'Kırsal',
  'coastal': 'Sahil',
  'wooden': 'Ahşap',
  'industrial': 'Endüstriyel',
  'italian': 'İtalyan',
  'traditional': 'Geleneksel',
  'original': 'Orijinal',
  'red': 'Kırmızı',
  'blue': 'Mavi',
  'green': 'Yeşil',
  'yellow': 'Sarı',
  'brown': 'Kahverengi',
  'white': 'Beyaz',
  'black': 'Siyah',
  'grey': 'Gri',
  'purple': 'Mor',
  'pink': 'Pembe',
  'orange': 'Turuncu'
};
